import {
  FieldCheckbox,
  FieldSelect,
  FieldText,
  FormFieldControl,
} from '@explorer/forms';
import { FormikProps } from 'formik';

import { FormValues } from '../../formSchema';
import { mtcCustomerTypesOptions } from './helper';

interface OverrideModuleProps {
  formik: FormikProps<FormValues>;
  formId: string;
}

export const OverrideMTC = ({ formik, formId }: OverrideModuleProps) => {
  return (
    <>
      <FormFieldControl
        key="control_components.MTC"
        formId={formId}
        formik={formik}
        name="control_components"
        renderField={(props) => (
          <FieldCheckbox
            {...props}
            options={[
              {
                label: { id: 'forms-presets.mtc.is-enabled' },
                name: 'MTC',
              },
            ]}
          />
        )}
      />
      <FormFieldControl
        key="control_components.MTC.customerType"
        formId={formId}
        formik={formik}
        name="mtc_details.customer_type"
        renderField={(props) => (
          <FieldSelect
            {...props}
            defaultValue={formik?.values?.mtc_details?.customer_type}
            label={{ id: 'forms-presets.mtc.customer-type' }}
            options={mtcCustomerTypesOptions}
          />
        )}
      />
      <FormFieldControl
        key="control_components.MTC.notes"
        formId={formId}
        formik={formik}
        name="mtc_details.notes"
        renderField={(props) => (
          <FieldText
            {...props}
            defaultValue={formik?.values?.mtc_details?.notes}
            fullWidth
            size="medium"
            label="Notes"
          />
        )}
      />
    </>
  );
};
